import react from 'react';
import { useBasketData } from 'app/hooks/accessors';
import { useDeliveryBasketData } from 'app/hooks/accessors/useDeliveryBasketData';
import { gql } from '@apollo/client';

const CART_DATA_FOR_MENU_QUERY = gql`
    query CART_DATA_FOR_MENU(
        $period: String!
    ) {
        cart(
            period: $period
        ) {
            type
            period
            isSubscriptionActivated
            totals {
                total_discount_price
                total_price
                delivery_price
            }
            discount_conditions {
                differenceBetweenPromocodeAndOrder
                discountValue
                discountType
                promocode
                isPromoCodeExists
            }
            sections {
                id
                items {
                    dish {
                        id
                    }
                }
                cartType
            }
        }
    }
`;

const DELIVERY_CART_DATA_FOR_MENU_QUERY = gql`
    query DELIVERY_CART_DATA_FOR_MENU(
        $deliveryId: ID!
    ) {
        cart: deliveryCart(
            delivery_id: $deliveryId,
        ) {
            type
            period
            totals {
                total_discount_price
                total_price
                delivery_price
            }
            discount_conditions {
                differenceBetweenPromocodeAndOrder
                discountValue
                discountType
                promocode
                isPromoCodeExists
            }
            sections {
                id
                items {
                    dish {
                        id
                    }
                }
                cartType
            }
        }
    }
`;

export function useBasketDataByLocation() {
    const isDeliveryBasket = window.location.pathname.includes('app/delivery');
    const deliveryId = window.location.pathname.split('/').find((e) => Boolean(e) && !Number.isNaN(Number(e)));

    const newBasket = useBasketData(CART_DATA_FOR_MENU_QUERY, 'useBasketDataByLocation');
    const deliveryBasket = useDeliveryBasketData(DELIVERY_CART_DATA_FOR_MENU_QUERY);

    const cart = isDeliveryBasket ? deliveryBasket : newBasket;
    return cart;
}
